import { Tab } from "semantic-ui-react";
import { connect } from "react-redux";
import CollectionPeriod from "./CollectionPeriod";
import React from "react";
import InterimCollections from "./InterimCollections";

const PrimaryTabs = (props) => {
  const { loadData, onDetailsRowClick } = props;

  const { optionShowCollDetailsCountTab } = props.logIn;
  
  const panes = [
    {
      menuItem: "Summary",
      pane: (
        <Tab.Pane>
          <CollectionPeriod loadData={loadData} allowShowMeters={true} />
        </Tab.Pane>
      ),
    },
    optionShowCollDetailsCountTab && {
      menuItem: "Count Details",
      pane: (
        <Tab.Pane>
          <InterimCollections onDetailsRowClick={onDetailsRowClick} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Tab
      renderActiveOnly={false}
      panes={panes}
      className="flex-stretch gs-flex-container-vertical h-60"
    />
  );
};

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, {
})(PrimaryTabs);
